export class Ged {
    idpiece: number;
    password: string;
    idprojet: number;
}



// WEBPACK FOOTER //
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/app/models/ged.ts